import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/introBreakdownSagas";
import { useDispatch, useSelector } from "react-redux";

const CustomDateRanges = () => {
  const dispatch = useDispatch();

  let { rangeOptions, selectedRangeOption } = useSelector((state) => state.introBreakdown);
  let onSelectChange = (data) => dispatch(actionCreators.updateCustomRange(data));

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      selectedFilters={selectedRangeOption}
      includeFilter={false}
      onSelectChange={onSelectChange}
    />
  );
};

export default CustomDateRanges;
